import { VFlex, Warning, new__cn as cn } from '@/package';

export const TrackIDChangeAlertSnackBar = ({
  message,
  variant = 'warning',
}: {
  message: string;
  variant?: 'error' | 'warning';
}) => {
  return (
    <VFlex
      className={cn('px-scale/8 py-scale/4', 'rounded-sm shadow-sm', {
        'bg-error-100 text-white': variant === 'error',
        'bg-warning-100 text-black': variant === 'warning',
      })}
      gap={0.25}
      items="center"
    >
      {variant === 'error' ? (
        <Warning className="size-4" />
      ) : (
        <Warning className="size-4 text-warning-500" />
      )}
      <div className="text-body-md wrap-break-word whitespace-pre-line">
        {message}
      </div>
    </VFlex>
  );
};

TrackIDChangeAlertSnackBar.displayName = 'TrackIDChangeAlertSnackBar';
